<template>
    <otif-select
        :field="field"
        :label="label"
        :description="description"
        :required="required"
        :values="ecmrepositorytypes"
        :value="value"
        @input="onInput"
        :loading="loading"
        :disabled="loading"
        :validation="validation"
        :invalidMessage="invalidMessage"
        :flag="flag">

    </otif-select>
</template>

<script>

import axios from 'axios';
import EcmRepositoryTypes from '@/ecm/collections/ecmrepositorytypes.js';

export default {

    data() {
        return {
            loading: true,
            ecmrepositorytype: '',
            ecmrepositorytypes: []
        }
    },

    props: ['field', 'label', 'description', 'required', 'value', 'validation','invalidMessage', 'flag'],

    created() {
        this.refresh();
    },

    methods: {
        refresh() {
            this.loading = true;
            const ecmrepositorytypes = new EcmRepositoryTypes();

            ecmrepositorytypes.fetch()
            .then(() => {
                var configs=[];
                var i = 0;
                for(i=0; i<ecmrepositorytypes.resources.length;i++)
                {
                    const rep = ecmrepositorytypes.resources[i];
                    if(rep)
                    {
                        if(rep.attributes.repositoryType == 'dbms_generic_v1' && this.flag == 'RDBMS')
                        {
                            configs.push(rep);
                        }
                        if(rep.attributes.repositoryType != 'dbms_generic_v1' && this.flag == 'ECM')
                        {
                            configs.push(rep);
                        }
                    }
                }
                this.ecmrepositorytypes = configs.map((ecmrepositorytype) => {
                    return {
                        label: ecmrepositorytype.id,
                        value: ecmrepositorytype.id,
                   }
                });
                this.loading = false;
            });
        },

        onInput(val) {
            if (val != this.value) {
                this.$emit('input', val);
            }
        }
    }

};

</script>
